import { packagesTypes } from './types';

const INITIAL_STATE = {
    data: {
        loading: false,
        success: false,
        error: false,
        packages: []
    },
    register: {
        loading: false,
        success: false,
        error: false,
    },
    vendors: {
        users: [],
        loading: false,
        success: false,
        error: false,
    },
    tradings: {
        users: [],
        loading: false,
        success: false,
        error: false,
    },
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case packagesTypes.PACKAGES_REQUEST:
            return {
                ...state,
                data: {
                    ...state.data,
                    loading: true,
                    success: false,
                    error: false,
                }
            };
        case packagesTypes.PACKAGES_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    packages: action.payload.data.packages,
                    success: true,
                    loading: false,
                    error: false
                }
            };
        case packagesTypes.PACKAGES_FAILURE:
            return {
                ...state,
                data: {
                    ...state.data,
                    success: false,
                    loading: false,
                    error: true
                }
            };

        case packagesTypes.REGISTER_REQUEST:
            return {
                ...state,
                register: {
                    loading: true,
                    success: false,
                    error: false,
                }
            };
        case packagesTypes.REGISTER_SUCCESS:
            return {
                ...state,
                register: {
                    ...state.register,
                    data: action.payload.data,
                    success: true,
                    loading: false,
                    error: false
                }
            };
        case packagesTypes.REGISTER_FAILURE:
            return {
                ...state,
                register: {
                    ...state.register,
                    data: action.payload.error,
                    success: false,
                    loading: false,
                    error: true
                }
            };
        case packagesTypes.REGISTER_RESET:
            return {
                ...state,
                register: {
                    ...INITIAL_STATE.register
                }
            };


        case packagesTypes.VENDORS_REQUEST:
            return {
                ...state,
                vendors: {
                    users: [],
                    loading: true,
                    success: false,
                    error: false,
                }
            };
        case packagesTypes.VENDORS_SUCCESS:
            return {
                ...state,
                vendors: {
                    ...state.vendors,
                    users: action.payload.data.users,
                    success: true,
                    loading: false,
                    error: false
                }
            };
        case packagesTypes.VENDORS_FAILURE:
            return {
                ...state,
                vendors: {
                    ...state.vendors,
                    users: [],
                    success: false,
                    loading: false,
                    error: true
                }
            };

        case packagesTypes.TRADINGS_REQUEST:
            return {
                ...state,
                tradings: {
                    users: [],
                    loading: true,
                    success: false,
                    error: false,
                }
            };
        case packagesTypes.TRADINGS_SUCCESS:
            return {
                ...state,
                tradings: {
                    ...state.tradings,
                    users: action.payload.data.users,
                    success: true,
                    loading: false,
                    error: false
                }
            };
        case packagesTypes.TRADINGS_FAILURE:
            return {
                ...state,
                tradings: {
                    ...state.tradings,
                    users: [],
                    success: false,
                    loading: false,
                    error: true
                }
            };

        default:
            return state;
    }
};

export default reducer;

